import { Children, ReactNode } from "react";
import * as ReactIs from "react-is";

export const childrenCount = (children?: ReactNode): number =>
  Children.toArray(children).reduce<number>(
    (res, c) => res + (!ReactIs.isFragment(c) ? 1 : childrenCount(c.props.children)),
    0
  );
